<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
  <v-card>
    <v-card-title
      class="headline lighten-2"
      primary-title
    >
      Login Required
    </v-card-title>

    <v-card-text>
      <p class="text-center title font-weight-light">
        {{text}}
      </p>
    </v-card-text>


    <v-card-actions>
      <v-btn
        text
        @click="close"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        class="ml-auto"
        tile
        @click="login"
      >
        Login
      </v-btn>
    </v-card-actions>
  </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'LoginRequired',
    data() {
        return {
            dialog: false,
            text: ''
        }
    },
    methods: {
      showDialog(text){
          this.dialog = true;
          if(!text)
              this.text = 'You need to log in to do this action';
          else
              this.text = text;
      },
      close(){
          this.dialog = false;
      },
      login() {
          this.$router.push({name: 'Login'})
      }
    }
  }
</script>

<style lang="sass">
  #view
    padding-bottom: 20px
</style>
